import * as React from "react";

const SvgRadio = props => <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g><circle cx={8} cy={8} r={7} stroke="currentColor" strokeWidth={2} /><circle cx={8} cy={8} r={3.5} fill="currentColor" /></g></svg>;

export default SvgRadio;